import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { docsStructure } from '../../docs';

const DocsBreadcrumb = () => {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  // Don't show breadcrumb on docs home
  if (pathParts.length <= 1) return null;
  
  const sectionId = pathParts[1];
  const pageSlug = pathParts[2];
  
  const section = docsStructure.find(s => s.id === sectionId);
  const page = section?.pages.find(p => p.slug === pageSlug);
  
  return (
    <nav className="flex items-center gap-2 text-sm text-foreground/60 mb-6 pb-4 border-b border-border/40">
      <Link 
        to="/docs" 
        className="hover:text-foreground transition-colors flex items-center gap-1"
      >
        <Home className="h-4 w-4" />
        <span>Docs</span>
      </Link>
      
      {section && (
        <>
          <ChevronRight className="h-4 w-4" />
          <span className="text-foreground/80">{section.title}</span>
        </>
      )}
      
      {page && (
        <>
          <ChevronRight className="h-4 w-4" />
          <span className="text-foreground font-medium">{page.title}</span>
        </>
      )}
    </nav>
  );
};

export default DocsBreadcrumb;

